import { render, staticRenderFns } from "./NavigationBottom.vue?vue&type=template&id=58be2268&scoped=true&"
import script from "./NavigationBottom.vue?vue&type=script&lang=js&"
export * from "./NavigationBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58be2268",
  null
  
)

export default component.exports